import { Box, Button, Card, CardContent, Grid, IconButton, InputAdornment, TextField } from '@material-ui/core';
import ArrayFields from '../ArrayFields';
import React from 'react';
import { observer } from 'mobx-react';
import MainAuthorEditor from '../../../general/MainAuthorEditor';
import AddIcon from '@material-ui/icons/Add';
import DatePicker from '../../../general/DatePicker';
import moment from 'moment/moment';
import RttIcon from '@mui/icons-material/Rtt';

const GeneralTab = observer(({ mainBookFormStore, userStore }) => {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid container spacing={2} item xs={2}>
            <Grid item>
              {mainBookFormStore.loadedImage && (
                <Box><img alt="cover" src={mainBookFormStore.loadedImage}
                          style={{ maxWidth: '100%' }} /><br /><br /></Box>)}

              <TextField label="Url da Imagem"
                         onChange={e => mainBookFormStore.setFormData('cover_url', e.target.value)}
                         fullWidth
                         value={mainBookFormStore.formData['cover_url'] ?? ''} />
              <Button onClick={e => mainBookFormStore.setLoadedImage(mainBookFormStore.formData.cover_url)}>Carregar
                imagem</Button>
              <Button onClick={e => mainBookFormStore.setLoadedImage(null)} color="error">Carregar Capa Padrão</Button>
            </Grid>
          </Grid>
          <Grid container spacing={4} item xs={10}>
            <Grid item xs={6}>
              <TextField error={mainBookFormStore.errors['title']} label="Título"
                         onChange={e => mainBookFormStore.setFormData('title', e.target.value)}
                         fullWidth
                         name="title"
                         value={mainBookFormStore.formData['title']} />
            </Grid>
            <Grid item xs={6}>
              <TextField error={mainBookFormStore.errors['subtitle']} label="Subtítulo"
                         onChange={e => mainBookFormStore.setFormData('subtitle', e.target.value)}
                         fullWidth
                         name="subtitle"
                         value={mainBookFormStore.formData['subtitle']} />
            </Grid>
            {mainBookFormStore.formData.authors.map((author, index) => {
              return (
                <Grid item key={index}>
                  <MainAuthorEditor author={author} userStore={userStore} key={index}
                                    setAuthor={(author) => {
                                      const authors = [...mainBookFormStore.formData.authors];
                                      authors[index] = author;
                                      mainBookFormStore.setFormData('authors', [...authors]);
                                    }}
                                    onRemove={() => {
                                      const authors = [...mainBookFormStore.formData.authors];
                                      authors.splice(index, 1);
                                      mainBookFormStore.setFormData('authors', [...authors]);
                                    }}
                  />
                </Grid>
              );
            })}
            <Grid item>
              <Button size="large" onClick={() => {
                const authors = [...mainBookFormStore.formData.authors];
                authors.push({ id: null, name: null });
                mainBookFormStore.setFormData('authors', [...authors]);
              }}>
                <AddIcon />
              </Button>
            </Grid>

            {/*<ArrayFields title='Autor' error={mainBookFormStore.errors.authors}*/}
            {/*             data={mainBookFormStore.formData.authors} onChange={(newArray) => {*/}
            {/*  mainBookFormStore.setFormData('authors', [...newArray]);*/}
            {/*}} />*/}
            <Grid item xs={12}>
              <TextField error={mainBookFormStore.errors['description']} label="Sinopse"
                         onChange={e => mainBookFormStore.setFormData('description', e.target.value)}
                         fullWidth
                         minRows={4}
                         multiline
                         name="description"
                         value={mainBookFormStore.formData['description']} configurations={{ multiline: true }} />
            </Grid>
            <Grid item xs={12}>
              <ArrayFields title="Categoria" error={mainBookFormStore.errors.categories}
                           data={mainBookFormStore.formData.categories}
                           name="categories"
                           defaultWord="Livros"
                           onChange={(newArray) => {
                             mainBookFormStore.setFormData('categories', newArray);
                           }} />
            </Grid>
            <Grid item xs={3}>
              <TextField error={mainBookFormStore.errors['language']} label="Idioma"
                         onChange={e => mainBookFormStore.setFormData('language', e.target.value)}
                         fullWidth
                         name="language"
                         value={mainBookFormStore.formData['language']}
                         InputProps={{
                           endAdornment: <InputAdornment position='end'>
                             <IconButton
                               edge='end'
                               onClick={() => {
                                 mainBookFormStore.setFormData('language', 'Português');
                               }}>
                               <RttIcon />
                             </IconButton>
                           </InputAdornment>
                         }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField error={mainBookFormStore.errors['pages_count']} label="Qtde. de Páginas"
                         onChange={e => mainBookFormStore.setFormData('pages_count', e.target.value)}
                         fullWidth
                         name="pages_count"
                         value={mainBookFormStore.formData['pages_count']} />
            </Grid>
            <Grid item xs={3}>
              <TextField error={mainBookFormStore.errors['publisher']} label="Editora"
                         onChange={e => mainBookFormStore.setFormData('publisher', e.target.value)}
                         fullWidth
                         name="publisher"
                         value={mainBookFormStore.formData['publisher']} />
            </Grid>
            <Grid item xs={3}>
              <DatePicker error={mainBookFormStore.errors['release_date']} label="Data de lançamento"
                          fullWidth
                          value={mainBookFormStore.formData['release_date']}
                          inputFormat='DD/MM/YYYY'
                          name="release_date"
                          onChange={(value) => {
                            if (moment(value).isValid()) {
                              mainBookFormStore.setFormData('release_date', value)
                            }
                          }}
              />
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

export default GeneralTab;
